const WaterLevel = (props) => {
    return (
        <div className='mt-1 cistern' style={{"--mask-step": props.waterLevel}}>
            <img className={`absolute ${props.widthHeight}`} src="/WaterLevel/cistern_background.png"/>
            <img className={`absolute waterLevel ${props.widthHeight}`} src="/WaterLevel/cistern_level_indicator.png"/>
            {props.waterLevel <= "1" ? <img className={`absolute ${props.widthHeight}`} src="/WaterLevel/cistern_outline_min.png"/> 
            : props.waterLevel === "5" ? <img className={`absolute ${props.widthHeight}`} src="/WaterLevel/cistern_outline_max.png"/> 
            : <img className={`absolute ${props.widthHeight}`} src="/WaterLevel/cistern_outline.png"/> }
            <div className={`absolute ${props.textClass} ${props.widthHeight}`}>
                <h1 className={``}>{props.waterLevel}</h1>
            </div>
        </div>
    )    
}

export { WaterLevel };